import React, { ReactElement, useEffect } from 'react'
import { Radio, FormControl, FormLabel, RadioGroup, FormControlLabel, Typography, useTheme, Grid, Divider } from '@material-ui/core';
import { C_VALUE } from '../../types/types';
import { useIntl, FormattedHTMLMessage } from 'react-intl';
import { ProductInputDataRequiredFields } from '../../redux/product/productTypes';
import { Panel } from '@ktr/ktr-materialui-react';
import isFieldEmpty from '../../service/IsFieldEmpty';


interface Props {
    c_VALUES: Array<C_VALUE>,
    c_value: number | null | undefined,
    inputChanged(productInputData: any): any,
    errorFields?: ProductInputDataRequiredFields,
}


function HubCValue(props: Props): ReactElement {
    const [inputValues, setInputValues] = React.useState({ c_value: props.c_value || [] });
    const { formatMessage: f } = useIntl();
    const theme = useTheme();

    //diese methode ist dazu da um die werte aus den gespeicherten URLS (get parameter) auszulesen bzw. in den intialen state der komponente zu schreiben
    useEffect(() => {
        setInputValues({ c_value: props.c_value || [] });
    }, [props.c_value])

    //only needed for the point in the radio button. so that the radio button knows that it is pressed.
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): any => {
        setInputValues({ ...inputValues, c_value: +(event.target as HTMLInputElement).value });
        props.inputChanged({ ...inputValues, c_value: +(event.target as HTMLInputElement).value });
    };

    const getCValuePicture: any = (cvalue: number) => {
        if (cvalue === 0.6) {
            //return require("../../images/794567_c_0-6.jpg")
            return require("../../images/794567_c_0-6_neu-2.png")
        } else if (cvalue === 0.8) {
            //return require("../../images/794565_c_0-8.jpg")
            return require("../../images/794565_c_0-8_neu-2.png")
        } else if (cvalue === 1.0) {
            //return require("../../images/794562_c_1.jpg")
            return require("../../images/794562_c_1_neu-2.png")
        }
    }

    
    return (
        <Panel title={<b>{f({ id: 'app.hub.resultingc-val', defaultMessage: 'Resulting hubform c-value:' })}</b>}>
            <FormControl component="fieldset">
                <FormLabel component="legend" style={{ color: theme.palette.text.primary }}>  </FormLabel>
                <RadioGroup style={props.errorFields !== undefined && props.errorFields.c_value && isFieldEmpty(props.c_value) ? {border: "1px solid", borderColor: "red"} : undefined}  value={inputValues.c_value} onChange={handleChange} row>
                    <Grid container>
                        {
                            props.c_VALUES ?
                                //iterate through all c-values to show the radio buttons...coming from the db depends on the product type
                                props.c_VALUES.map((val, index) => {
                                    return (
                                        <Grid container key={index}>
                                            <Grid sm={6} xs={12} item style={{ padding: "5px" }}>
                                                <img alt="c-value" style={{ maxWidth: '300px', width: '80%' }} src={getCValuePicture(val.c_VALUE)} />
                                            </Grid>
                                            <Grid sm={6} xs={12} item style={{ textAlign: "left" }}>
                                                <Grid item xs={12}>
                                                    {val.c_VALUE === 0.8 ?
                                                        <span>
                                                            <b> {f({ id: 'app.cvalue.info0_8.1' })}</b> <br /><br />
                                                            {f({ id: 'app.cvalue.info0_8.2' })} <br /><br />
                                                            <FormattedHTMLMessage id="app.cvalue.info0_8.3" /><br /><br />
                                                        </span> : ""}

                                                    {val.c_VALUE === 1.0 ?
                                                        <span>
                                                            <b> {f({ id: 'app.cvalue.info1_0.1' })}</b> <br /><br />
                                                            {f({ id: 'app.cvalue.info1_0.2' })} <br /><br />
                                                        </span> : ""}

                                                    {val.c_VALUE === 0.6 ?
                                                        <span>
                                                            <b> {f({ id: 'app.cvalue.info0_6.1' })}</b> <br /><br />
                                                            {f({ id: 'app.cvalue.info0_6.2' })} <br /><br />
                                                            <FormattedHTMLMessage id="app.cvalue.info0_6.3" /> <br /><br />
                                                        </span> : ""}

                                                </Grid>
                                                <Grid item xs={12}>


                                                    <FormControlLabel
                                                        style={{ marginLeft: "0px" }}
                                                        key={index}
                                                        value={val.c_VALUE}
                                                        // // here we need  ==  and not ===
                                                        control={
                                                            //@ts-ignore
                                                            <Radio checked={inputValues.c_value === val.c_VALUE} />
                                                        }
                                                        label={f({ id: 'app.cvalue.heading.start' }) + " " + val.c_VALUE + " " + f({ id: 'app.cvalue.heading.end' })} />
                                                </Grid>


                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider></Divider>
                                            </Grid>
                                        </Grid>



                                    )
                                }) : ""
                        }
                    </Grid>
                </RadioGroup>
                { /* the error check for the c-value */}
                {props.errorFields !== undefined && props.errorFields.c_value && isFieldEmpty(props.c_value) ?
                    <Typography style={{ textAlign: "center", fontSize: "0.8rem", color: theme.palette.error.main }}>
                        {f({ id: 'app.error.required', defaultMessage: 'Required' })}
                    </Typography>
                    : ""}
            </FormControl>
        </Panel>
    )
}

export default HubCValue;

